import { FC, memo } from 'react';

import InstructorTemplate from '../../components/instructur-template/InstructorTemplate';
import { InstructorTemplateProps } from '../../components/instructur-template/type';
import Route from '../../components/route/Route';
import { RoutePath } from '../../components/route/type';

const DATA: InstructorTemplateProps = {
  cv: ['geboren 1987 in Moskau (Russland)', 'seit 1995 professionelles Sport-Tanzen'],
  img: {
    alt: 'Elena Zander, Organisatorische Leitung und Ausbilderin der Systema Akademie Berlin',
    src: '/img/profile-elena-zander-250.jpg',
  },
  name: 'Elena Zander',
  school: {
    name: 'Systema Akademie Berlin',
    url: 'https://www.systema-berlin.de',
  },
  systema: [
    <>
      2013 - 2014 <Route href={RoutePath.SystemaRyabko}>Systema Ryabko</Route> (
      <Route href={RoutePath.FalkoZander}>Falko Zander</Route>)
    </>,
    <>
      seit 2014 <Route href={RoutePath.SolovevStyle}>Solovev Defense</Route> (Falko Zander)
    </>,
    <>
      seit 2014 <Route href={RoutePath.KampkunstPu}>Privatschüler</Route> von Falko Zander
    </>,
    <>
      seit 2018 <Route href={RoutePath.KampfkunstVip}>VIP-Programm</Route>, Systema Akademie Berlin
    </>,
    <>Organisatorische Leitung, Systema Akademie Berlin</>,
    <>
      <Route href={RoutePath.KampfkunstInstructorProgram}>Senior Instructor</Route>, Solovev Defense
    </>,
    <>
      <Route href={RoutePath.KampfkunstRanking}>8. Schülergrad</Route>, Solovev Defense
    </>,
  ],
};

const ElenaZander: FC = () => <InstructorTemplate {...DATA} />;
export default memo(ElenaZander);
